/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

/** Same tab/FK mapping already duplicated in socketHandler.js's `keyName` map. */
const FK_TO_TAB = {
    il_ocean_import_id: 0,
    il_ocean_export_id: 1,
    il_air_import_id: 2,
    il_air_export_id: 3,
    il_ftl_ltl_id: 4,
};

const rateManagementSlice = createSlice({
    name: 'rateManagementData',
    initialState: [],
    reducers: {
        setRateManagementData: (_state, action) => action.payload,
        /** 부모 검색 행(`rm-{tab}-{pk}`)의 il_rate 에 추가한다. 같은 id 가 이미 있으면(broadcast 와 ack 가 둘 다 오는 경우) 무시. */
        addRateManagementData: (state, action) => {
            const entry = action.payload;
            const fkField = Object.keys(FK_TO_TAB).find((k) => entry[k] != null);
            if (!fkField) return;
            const row = state.find((r) => r.id === `rm-${FK_TO_TAB[fkField]}-${entry[fkField]}`);
            if (!row) return;
            if (!row.il_rate) row.il_rate = [];
            if (!row.il_rate.some((r) => r.id === entry.id)) row.il_rate.push(entry);
        },
        updateRateManagementData: (state, action) => {
            const { id, newData } = action.payload;
            for (const row of state) {
                const idx = row.il_rate?.findIndex((r) => r.id === id) ?? -1;
                if (idx !== -1) {
                    row.il_rate[idx] = { ...row.il_rate[idx], ...newData };
                    break;
                }
            }
        },
        deleteRateManagementData: (state, action) => {
            const idToDelete = action.payload;
            for (const row of state) {
                if (row.il_rate?.some((r) => r.id === idToDelete)) {
                    row.il_rate = row.il_rate.filter((r) => r.id !== idToDelete);
                    break;
                }
            }
        },
    },
});

export const { setRateManagementData, addRateManagementData, updateRateManagementData, deleteRateManagementData } =
    rateManagementSlice.actions;
export default rateManagementSlice.reducer;
